import * as actionTypes from "../constants/actionTypes";
import * as rccHelper from "../helpers/rccReducerHelper";

import * as rcc from "../constants/rcc";

import Spectro from "../models/utils/Spectro";

const initialState = {
    active: null,
    configuration: null,
    spectro: new Spectro(1),
    typeList: [],
    measureModes: [
        {id: 1, name: rcc.SPECTRO_MODE_45},
        {id: 2, name: rcc.SPECTRO_MODE_FLAT},
        {id: 3, name: rcc.SPECTRO_MODE_MATTE},
        {id: 4, name: rcc.SPECTRO_MODE_EGGSHELL},
        {id: 5, name: rcc.SPECTRO_MODE_PEARL},
        {id: 6, name: rcc.SPECTRO_MODE_SATIN},
        {id: 7, name: rcc.SPECTRO_MODE_SEMI_GLOSS},
        {id: 8, name: rcc.SPECTRO_MODE_GLOSS}
    ],
    xRiteModels: [],
    comPorts: []
};

/**
 * Structure of spectro store:
 * - active         {Object | null}
 * - configuration  {Object | null}
 * - spectro        {Object}            If spectro.isConnected is true, rcc is connected to spectro device
 * - typeList       {Array}
 * - measureModes   {Array}
 * - xRiteModels    {Array}
 * - comPorts       {Array}
 */
export const spectroReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RCC_WEBSOCKET_CLOSED:
            return {
                ...initialState,
                spectro: state.spectro.reset()
            };
        case actionTypes.SPECTRO_SET_SELECT:
            return {
                ...state,
                spectro: state.spectro.updateSelected(action.payload.result)
            };
        case actionTypes.SPECTRO_SET_CONNECTION:
            return {
                ...state,
                spectro: state.spectro.updateConnected(action.payload.connected)
            };
        case actionTypes.SAVE_SPECTRO_CALLS:
            return {
                ...state,
                spectro: state.spectro.updateMethods(action.payload.methods)
            };
        case actionTypes.SAVE_SPECTRO_INFO:
            return {
                ...state,
                spectro: state.spectro.updateInfo(
                    action.payload.data.name !== undefined ? action.payload.data.name : "",
                    action.payload.data.serialNumber !== undefined ? action.payload.data.serialNumber : "",
                    action.payload.data.type !== undefined ? action.payload.data.type : null,
                    action.payload.data.typeName !== undefined ? action.payload.data.typeName : "",
                    action.payload.data.spectral !== undefined ? action.payload.data.spectral : false
                )
            };
        case actionTypes.SAVE_SPECTRO_CALIBRATED:
            return {
                ...state,
                spectro: state.spectro.updateCalibrated(action.payload.calibrated === true)
            };
        case actionTypes.SAVE_SPECTRO_DIALOG:
            return {
                ...state,
                spectro: state.spectro.updateDialog(action.payload.dialog)
            };
        case actionTypes.CANCEL_SPECTRO_DIALOG:
            return {
                ...state,
                spectro: state.spectro.updateDialog(null)
            };
        case actionTypes.SAVE_SPECTRO_MEASURE_RESULT:
            return {
                ...state,
                spectro: state.spectro.updateResult(action.payload.result)
            };
        case actionTypes.UPDATE_SPECTRO_PREVIEW:
            return {
                ...state,
                spectro: state.spectro.updateImagePreview(action.payload.image)
            };
        case actionTypes.SAVE_SPECTRO_TYPES:
            return {
                ...state,
                typeList: rccHelper.processList(action.payload.typeList)
            };
        case actionTypes.INIT_SPECTRO_CONFIGURATION:
        case actionTypes.SAVE_SPECTRO_CONFIGURATION:
            return {
                ...state,
                active: rccHelper.parseDefaultSpectroType(action.payload.configuration),
                configuration: rccHelper.parseSpectroTypes(action.payload.configuration, state.typeList)
            };
        case actionTypes.SAVE_SPECTRO_XRITE_MODELS:
            return {
                ...state,
                xRiteModels: action.payload.xRiteModels
            };
        case actionTypes.SAVE_SPECTRO_COM_PORTS:
            return {
                ...state,
                comPorts: action.payload.comPorts
            };
        case actionTypes.DATABASE_CHANGE:
        case actionTypes.DATABASE_CHANGE_GAMMA:
            return {
                ...state,
                spectro: state.spectro.updateResult(null)
            };
        default:
            return state;
    }
};
